<div class="pr-notification-container">
  <ng-template eaNotificationHost></ng-template>
</div>
